module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal-confirm/modal-confirm.component.css
// module id = ./src/app/components/modal-confirm/modal-confirm.component.css
// module chunks = main